// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 764) return "static/chunks/764-7382a6a94d2f11c3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"167":"5631e66b52f0f17c","937":"b60dcff574eeca58"}[chunkId] + ".js";
};